module.exports = __webpack_public_path__ + "img/5.e5b1a3c8.jpg";